import { motion } from 'framer-motion';

export default function LessonLayout({ children, bottomNav }) {
  return (
    <div className="min-h-[calc(100vh-49px)] flex flex-col">
      <motion.div
        className="flex-1 flex justify-center px-6 py-10"
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, ease: 'easeOut' }}
      >
        <div className="w-full max-w-2xl">
          {children}
        </div>
      </motion.div>

      {bottomNav && (
        <div className="sticky bottom-0 bg-white/90 backdrop-blur-md border-t border-gray-200 px-6 py-4">
          <div className="max-w-2xl mx-auto flex items-center justify-between">
            {bottomNav}
          </div>
        </div>
      )}
    </div>
  );
}
